'use client'
import Image from 'next/image'
import { Button, Container } from '@/components'
import ReclameAqui from '../ReclameAqui'
import styles from './styles.module.scss'
import logoWhite from '/public/icons/logo-white.svg'
import logoPurple from '/public/icons/logo-purple.svg'
import logoPink from '/public/icons/logo-pink.svg'

import useClickWithScroll from '@/utils/browser/useClickWithScroll'

import instagramImage from '/public/icons/social/instagram.svg'
import youtubeImage from '/public/icons/social/youtube.svg'
import tiktokImage from '/public/icons/social/tiktok.svg'
import whatsappImage from '/public/icons/social/whatsapp.svg'

const socialLinks = [
  {
    href: 'https://www.instagram.com/academiafoguete/',
    src: instagramImage,
    alt: 'Instagram'
  },
  {
    href: 'https://www.youtube.com/c/LapaTeam',
    src: youtubeImage,
    alt: 'YouTube'
  },
  {
    href: 'https://www.tiktok.com/@academiafoguete',
    src: tiktokImage,
    alt: 'TikTok'
  }
]
const logoMap = {
  white: logoWhite,
  purple: logoPurple,
  pink: logoPink
}

export default function Footer({
  isSimple = false,
  showCTAsPlatform = true,
  showSocial = true,
  showPolicies = true,
  variant,
  secondaryVariant
}) {
  const { isHomePage, onClickItem } = useClickWithScroll()
  const logoFooter = logoMap[secondaryVariant] || logoWhite
  if (isSimple) {
    return (
      <footer className={styles.footer} aria-label="Site Footer">
        <Container classname={styles.simpleContainer}>
          <section className={styles.signatureDetail}>
            <p className={styles.title}>Detalhes da Assinatura</p>
            <p>
              Você terá 7 dias para experimentar, e caso desista, basta
              solicitar o reembolso dentro desse período que devolveremos
              integralmente o valor pago. E para garantir que você continue
              evoluindo nos seus treinos e não tenha interrupções no acesso ao
              conteúdo da Academia Foguete, a sua assinatura é renovada
              automaticamente pelo mesmo período e valor contratados, até que
              você opte por cancelá-la, conforme explicado em nossos Termos de
              Uso.
            </p>
            <p className={styles.title}>
              <a
                href="https://academiafoguete.com.br/politica-de-privacidade"
                rel="nofollow"
                target="_blank"
              >
                Política de Privacidade
              </a>
              <a
                href="https://academiafoguete.com.br/termos-e-condicoes"
                rel="nofollow"
                target="_blank"
              >
                Termos e Condições
              </a>
              <a
                href="https://forms.gle/uZCHR3iP1GnZwYbr6"
                rel="nofollow"
                target="_blank"
              >
                Trabalhe conosco
              </a>
            </p>
          </section>
          <Image
            quality={100}
            src={logoFooter}
            alt="Logo Foguete"
            width={logoFooter.width}
            height={logoFooter.height}
          />
        </Container>
      </footer>
    )
  }

  return (
    <footer
      className={`${styles.footer} ${styles[`footer--${variant}`]}`}
      aria-label="Site Footer"
    >
      <Container
        classname={`${styles.container} ${styles[`container--${variant}`]}`}
      >
        <Image
          quality={100}
          src={logoFooter}
          alt="Logo Foguete"
          width={224}
          height={40}
        />
        {showPolicies && (
          <nav className={styles.links} aria-label="Footer Links">
            <a
              href="https://academiafoguete.com.br/politica-de-privacidade"
              rel="nofollow"
              target="_blank"
            >
              Política de Privacidade
            </a>
            <a
              href="https://academiafoguete.com.br/termos-e-condicoes"
              rel="nofollow"
              target="_blank"
            >
              Termos e Condições
            </a>
            <a
              href="https://forms.gle/uZCHR3iP1GnZwYbr6"
              rel="nofollow"
              target="_blank"
            >
              Trabalhe conosco
            </a>
            <ReclameAqui />
          </nav>
        )}
        {showSocial && (
          <section className={styles.social} aria-label="Redes Sociais">
            <p className={styles.socialTitle}>Nossas redes:</p>
            <div className={styles.icons}>
              {socialLinks.map(({ href, src, alt }) => (
                <a
                  key={alt}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Link para ${alt}`}
                >
                  <Image
                    quality={100}
                    src={src}
                    alt={alt}
                    width={24}
                    height={24}
                  />
                </a>
              ))}
            </div>
            <a
              href={'https://api.whatsapp.com/send/?phone=5521977152112'}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Link para Whatsapp`}
              className={styles.whatsapp}
            >
              <Image
                quality={100}
                src={whatsappImage}
                alt={'Whatsapp Icon'}
                width={24}
                height={24}
              />
              +55 21 97715-2112
            </a>
          </section>
        )}

        {showCTAsPlatform && (
          <div className={styles.ctaWrapper}>
            <Button
              variant="primary"
              size="small"
              className={styles.cta}
              onClick={() => {
                onClickItem('comparePlans', 0)
              }}
            >
              Embarque no Foguete
            </Button>
            <p className={styles.signin}>
              Já é aluno?
              <a href="https://app.academiafoguete.com.br/login">Entrar</a>
            </p>
          </div>
        )}
      </Container>
    </footer>
  )
}
